const UUID_PATTERN = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi

/**
 * Replaces every uuid segment in a URL with `:id`.
 *
 * Routes are `/patients/:patientId` and `/call/:encounterId`, so a URL sent to an
 * external error tracker otherwise carries a patient identifier. Sentry's `beforeSend`
 * filters `query_string` and `beforeBreadcrumb` drops the query off breadcrumb URLs,
 * but both keep the **path** — which is where the identifier lives, on the route as
 * well as on a FHIR read (`/fhir/R4/Patient/<uuid>`).
 */
export function scrubUuids(url: string): string {
  return url.replace(UUID_PATTERN, ':id')
}
